import styled from 'styled-components/macro';
import { Col } from '@yme/atoms/grid';
import { Image } from '@yme/atoms/image';
import { ButtonLink } from '@yme/molecules/buttons';
import { colorCoreBlack900Base, colorCoreBlack300 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { HeadingLevel2, HeadingLevel4, RegularTextLevel3, RegularTextLevel4, } from '@yme/tokens/typography';
export const ImageContainerStyled = styled(Col) `
  ${ADAPTIVE.maxWidth.tablet} {
    margin-bottom: 16px;
  }

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}
`;
export const ContentStyled = styled(Col) `
  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}
`;
export const ImageStyled = styled(Image) `
  margin-bottom: ${INDENT.xs};
  width: 100%;
  height: auto;

  ${ADAPTIVE.minWidth.tablet} {
    margin-bottom: 0;
  }
`;
export const TitleStyled = styled(HeadingLevel2) `
  margin-bottom: 8px;
  word-wrap: break-word;

  ${ADAPTIVE.maxWidth.tablet} {
    font-size: 24px;
    line-height: 28px;
  } ;
`;
export const SubtitleStyled = styled(HeadingLevel4) `
  margin-bottom: 16px;
  color: ${colorCoreBlack300};
`;
export const DescriptionStyled = styled(RegularTextLevel3) `
  margin-bottom: 16px;
  color: ${colorCoreBlack900Base};
`;
export const CaptionStyled = styled(RegularTextLevel4) `
  margin-top: 12px;
  color: ${colorCoreBlack300};
`;
export const ButtonLinkStyled = styled(ButtonLink) `
  & > span {
    display: inline-block;
  }
`;
